import { getDateStringFromResintRegNo } from "../common/date";
import { cmSvc, dcDiv, maritalStatus, militaryCat, sex } from "./data";

export default function BasicInformationItem(props) {
  const { data } = props;

  return (
    <div>
      {data.id == "Profile" && (
        <div>
          <div className="tabpanel-item">
            <div>
              <table>
                <tbody>
                  <tr>
                    {/* <th>사번:</th> */}
                    <th>Employee ID:</th>
                    <td>
                      <b>{data.employeeNo}</b>
                    </td>
                  </tr>
                  <tr>
                    {/* <th>성명:</th> */}
                    <th>Name:</th>
                    <td>
                      <b>{data.name}</b>
                    </td>
                  </tr>
                  <tr>
                    {/* <th>영문명:</th> */}
                    <th>English Name:</th>
                    <td>
                      <b>{data.enName}</b>
                    </td>
                  </tr>
                  <tr>
                    {/* <th>닉네임:</th> */}
                    <th>Nickname:</th>
                    <td>
                      <b>{data.nickName}</b>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div>
              <table>
                <tbody>
                  <tr>
                    {/* <th>주소:</th> */}
                    <th>Address:</th>
                    <td>
                      <b>
                        {data.addr}
                        {data.detsAddr ? `, ${data.detsAddr}` : ``}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    {/* <th>휴대전화:</th> */}
                    <th>Mobile Phone Number:</th>
                    <td>
                      <b>
                        {data.mob &&
                          `010-${data.mob.slice(0, 4)}-${data.mob.slice(4)}`}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    {/* <th>내선번호:</th> */}
                    <th>Extension Number:</th>
                    <td>
                      <b>{data.extNo}</b>
                    </td>
                  </tr>
                  <tr>
                    {/* <th>이메일:</th> */}
                    <th>Email (Companey Email):</th>
                    <td>
                      <b>{data.email}</b>
                    </td>
                  </tr>
                  <tr>
                    {/* <th>이메일 (개인):</th> */}
                    <th>Email (Personal Email):</th>
                    <td>
                      <b>{data.persEmail}</b>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div>
              <table>
                <tbody>
                  <tr>
                    {/* <th>주민등록번호:</th> */}
                    <th>Resident Registration Number:</th>
                    <td>
                      <b>
                        {data.resintRegNo &&
                          `${data.resintRegNo.slice(
                            0,
                            6
                            // )}-${data.resintRegNo.slice(6)}`}
                          )}-${data.resintRegNo.slice(6, 7)}******`}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    {/* <th>생일:</th> */}
                    <th>Birth Date:</th>
                    <td>
                      <b>
                        {/* {data.resintRegNo &&
                          getDateStringFromResintRegNo(data.resintRegNo)} */}
                        {data.dob}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    {/* <th>성별:</th> */}
                    <th>Gender:</th>
                    <td>
                      <b>{sex[data.sex]}</b>
                    </td>
                  </tr>
                  <tr>
                    {/* <th>결혼여부:</th> */}
                    <th>Marital Status:</th>
                    <td>
                      <b>{maritalStatus[data.maritalStatus]}</b>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
      {data.id == "Emergency Info." && (
        <div>
          <div className="tabpanel-item">
            <div>
              <table>
                <tbody>
                  <tr>
                    {/* <th>관계:</th> */}
                    <th>Relationship:</th>
                    <td>
                      <b>{data.emergCtcNetRelatsh}</b>
                    </td>
                  </tr>
                  <tr>
                    {/* <th>성명:</th> */}
                    <th>Name:</th>
                    <td>
                      <b>{data.emergCtcNetName}</b>
                    </td>
                  </tr>
                  <tr>
                    {/* <th>연락처:</th> */}
                    <th>Contact:</th>
                    <td>
                      <b>{data.emergCtcNetCtc}</b>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
      {data.id == "Military Service" && (
        <div>
          <div className="tabpanel-item">
            <div>
              <table>
                <tbody>
                  <tr>
                    {/* <th>군복무이수여부:</th> */}
                    <th>Military Service Completion Status:</th>
                    <td>
                      <b>{cmSvc[data.cmSvc]}</b>
                    </td>
                  </tr>
                  <tr>
                    {/* <th>군별:</th> */}
                    <th>Military Branch:</th>
                    <td>
                      <b>
                        {data.militaryCat == "9"
                          ? data.otrMilitaryCat
                          : militaryCat[data.militaryCat]}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    {/* <th>입대일:</th> */}
                    <th>Enlistment Date:</th>
                    <td>
                      <b>{data.enlmtDate}</b>
                    </td>
                  </tr>
                  <tr>
                    {/* <th>전역일:</th> */}
                    <th>Discharge Date:</th>
                    <td>
                      <b>{data.dcDate}</b>
                    </td>
                  </tr>
                  <tr>
                    {/* <th>전역구분:</th> */}
                    <th>Discharge Type:</th>
                    <td>
                      <b>
                        {data.dcDiv == "9" ? data.otrDcDiv : dcDiv[data.dcDiv]}
                      </b>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
